<template>
  <div class="container-fluid generalConfig weflix-admin-general">
    <TitlePage title="Configurações Gerais" subtitle="Personalize o sistema Weflix" :hasMargin="false" />

    <div class="settings-layout" v-if="hasReady">
      <div class="settings-panel contetContainerEditVideo">
        <div class="setting-row">
          <div class="setting-copy">
            <label class="setting-label" for="setting-cart-closure">Fechamento de carrinho</label>
          </div>
          <div class="setting-aside">
            <span class="setting-status" :class="cartClosure ? 'active' : 'inactive'" aria-hidden="true">
              {{ cartClosure ? 'Ativado' : 'Inativo' }}
            </span>
            <div class="form-check form-switch">
              <input
                id="setting-cart-closure"
                class="form-check-input"
                type="checkbox"
                role="switch"
                v-model="cartClosure"
              />
            </div>
          </div>
        </div>

        <div class="setting-row">
          <div class="setting-copy">
            <label class="setting-label" for="setting-installment-checkout">Exibir valor parcelado no checkout</label>
          </div>
          <div class="setting-aside">
            <span class="setting-status" :class="showInstallmentValue ? 'active' : 'inactive'" aria-hidden="true">
              {{ showInstallmentValue ? 'Ativado' : 'Inativo' }}
            </span>
            <div class="form-check form-switch">
              <input
                id="setting-installment-checkout"
                class="form-check-input"
                type="checkbox"
                role="switch"
                v-model="showInstallmentValue"
              />
            </div>
          </div>
        </div>
      </div>

      <div class="actions configGeneralWeflix">
        <v-btn variant="flat" color="primary" size="large" min-width="160" class="settings-save-btn" @click="updateCompany">
          Salvar alterações
        </v-btn>
      </div>
    </div>
  </div>
  
  <div v-if="!hasReady" class="loader-overlay">
    <div class="loader-spinner"></div>
  </div>
</template>

<script>
import apiCompany from '@/utils/Weflix/company';
import { mapState, mapActions } from 'vuex';
import { toast } from 'vue3-toastify';
import TitlePage from '@/components/Weflix/titlePage.vue';

export default {
    data(){
        return{
            company: [],
            receivablesAdvance: false,
            mediaComments: false,
            cartClosure: false,
            googleSignIn: false,
            showInstallmentValue: false,
            id: '',
            hasReady: false,
        }
    },
    computed: {
        ...mapState(['token'])
    },
    components: {
        TitlePage
    },
    methods: {
        ...mapActions(['storeCurrentCollections']),

        async getCompany(){
            try {
                const response = await apiCompany.getCompany(this.token);
                this.company = response;
                this.receivablesAdvance = response.anticipation === 1 ? true : false;
                this.mediaComments = response.videoComments === 1 ? true : false;
                this.cartClosure = response.cartStatus === 1 ? true : false;
                this.showInstallmentValue = response.intallmentCheckout === 1 ? true : false;
                this.id = response.id;
                this.hasReady = true;
            } catch (error) {
                console.error(error);
            }
        },
        async updateCompany(){
            this.hasReady = false;
            const payload = {
                "anticipation": this.receivablesAdvance ? 1 : 0,
                "videoComments": this.mediaComments ? 1 : 0,
                "cartStatus": this.cartClosure ? 1 : 0,
                "intallmentCheckout": this.showInstallmentValue ? 1 : 0,
                "name": this.company.name,
            }
            try {
                const response = await apiCompany.editCompany(this.token, payload);
                this.hasReady = true;
                this.notify('Configurações atualizadas com sucesso!', 'success');
            } catch (error) {
                this.notify('Erro ao atualizar configurações!', 'error');
                console.error(error);
            }
        },
        notify(message, type = "info") {
            toast(message, {
                autoClose: 3000,
                position: 'top-right',
                theme: "light", 
                limit: 1,
                type: type,
                dangerouslyHTMLString: true
            });
        },
    }, 
    created(){
        this.getCompany();
    }
}
</script>

<style scoped>
.container-fluid.generalConfig.weflix-admin-general {
  max-width: 100% !important;
  width: 100% !important;
  margin: 0;
  padding: 20px;
  min-height: 100%;
  position: relative;
  box-sizing: border-box;
}

.titleContainer {
  margin-bottom: 28px;
}

.titleContainer h3 {
  font-size: 24px;
  font-weight: 600;
  color: #333;
  margin-bottom: 5px;
}

.titleContainer small {
  color: #666;
  font-size: 14px;
}

.settings-layout {
  width: 100%;
  max-width: 100%;
  display: flex;
  flex-direction: column;
  gap: 1.25rem;
}

.contetContainerEditVideo.settings-panel {
  display: flex;
  flex-direction: column;
  flex-wrap: nowrap;
  gap: 0;
  width: 100%;
  max-width: 100%;
  background: transparent;
  border: none;
  border-radius: 0;
  box-shadow: none;
  overflow: visible;
}

.setting-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 1.25rem 2rem;
  min-height: 4.25rem;
  padding: 1.25rem 1.75rem;
  padding-left: 0;
  padding-right: 0;
  border: none;
}

.setting-copy {
  flex: 1;
  min-width: 0;
}

.setting-label {
  font-size: 1rem;
  font-weight: 600;
  color: #1f2937;
  line-height: 1.45;
  margin: 0;
  cursor: pointer;
}

.setting-aside {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  flex-shrink: 0;
}

.setting-status {
  font-size: 0.6875rem;
  padding: 0.35rem 0.65rem;
  border-radius: 999px;
  font-weight: 600;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  white-space: nowrap;
}

.setting-status.active {
  background-color: #dcfce7;
  color: #166534;
}

.setting-status.inactive {
  background-color: #fee2e2;
  color: #991b1b;
}

.form-check {
  display: flex;
  align-items: center;
  padding: 0;
  margin: 0;
}

.form-check-input {
  width: 2.75rem !important;
  height: 1.5rem !important;
  background-color: #e5e7eb;
  border: none;
  border-radius: 999px;
  position: relative;
  cursor: pointer;
  transition: background-color 0.2s ease;
  appearance: none;
  flex-shrink: 0;
}

.form-check-input:checked {
  background-color: #250891 !important;
  border-color: #250891 !important;
}

.form-check-input::before {
  content: '';
  position: absolute;
  width: 1.25rem;
  height: 1.25rem;
  border-radius: 50%;
  background-color: white;
  top: 2px;
  left: 2px;
  transition: transform 0.2s ease;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.12);
}

.form-check-input:checked::before {
  transform: translateX(1.25rem);
}

.actions.configGeneralWeflix {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  width: 100%;
  padding: 0;
  margin: 0;
  position: relative;
  bottom: auto;
  right: auto;
}

.settings-save-btn {
  font-weight: 600;
  letter-spacing: 0.02em;
}

.loader-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
}

.loader-spinner {
  width: 40px;
  height: 40px;
  border: 4px solid #f3f4f6;
  border-top: 4px solid #250891;
  border-radius: 50%;
  animation: spin 1s linear infinite;
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}

@media (max-width: 768px) {
  .container-fluid.generalConfig.weflix-admin-general {
    padding: 15px;
  }

  .setting-row {
    flex-wrap: wrap;
    align-items: flex-start;
    min-height: 0;
    padding: 1.125rem 1.25rem;
  }

  .setting-aside {
    width: 100%;
    justify-content: space-between;
    padding-top: 0.5rem;
  }

  .setting-copy {
    width: 100%;
  }

  .actions.configGeneralWeflix .settings-save-btn {
    width: 100%;
  }
}
</style>